import React from 'react';
import sortByFactorName from './Components/Factor.Utils';
import FactorPanel from './Components/FactorPanel';
import { useCandidatesResultsContext } from '../../../../../Contexts/CandidateResultsContext';

function FactorsPanel(): React.JSX.Element {
    const { results } = useCandidatesResultsContext();
    const { personalityScore } = results;

    const factors = personalityScore?.factors || [];

    return (
        <div className="grid grid-cols-1 gap-y-10 py-10 lg:grid-cols-2 lg:gap-x-16">
            {factors.sort(sortByFactorName).map((factor) => (
                <FactorPanel key={factor.factorName} factor={factor} />
            ))}
        </div>
    );
}

export default FactorsPanel;
